'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergePaymentParameters = mergePaymentParameters;
exports.extractInstructions = extractInstructions;

var _lodash = require('lodash');

function mergePaymentParameters(defaultList, pipoList) {
    return defaultList.slice().map(function (p) {
        var found = (0, _lodash.find)(pipoList, { slug: p.slug });

        if (found) {
            p.title = p.lang_data_rus = found.title ? found.title : p.title;
        }

        return p;
    });
}

function extractInstructions(pipoList) {
    var result = {};

    if (!Array.isArray(pipoList)) {
        return result;
    }

    pipoList.reduce(function (r, p) {
        if (p.instruction) {
            r[p.slug] = p.instruction;
        }
        return r;
    }, result);
    return result;
}


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/utils.js
// module id = 384
// module chunks = 0